import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-9 mx-auto overflow-x-hidden" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = { class: "container-fluid px-0 mt-0" }
const _hoisted_4 = {
  key: 2,
  class: "row"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 3,
  class: "row"
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "disclaimer" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 4,
  class: "row mt-4"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 5,
  class: "row mt-4"
}
const _hoisted_13 = { class: "container-fluid" }

import { ref, computed, onMounted } from "vue";
import WorkflowNavigation from "@/guiide/components/common/WorkflowNavigation.vue";
import OrigenAdvice from "./finish/OrigenAdvice.vue";
import Plan from "./finish/Plan.vue";
import GenericCostOfAdvice from "./finish/GenericCostOfAdvice.vue";
import OptionsNowYouHaveAPlan from "./finish/OptionsNowYouHaveAPlan.vue";
import RiskWarnings from "./finish/RiskWarnings.vue";
import AdvisorsList from "@/guiide/components/common/AdvisorsList.vue";
import AnnuityProvidersList from "./common/AnnuityProvidersList.vue";
import PageNav from "@/guiide/components/common/PageNav.vue";
import TrustPilot from "./common/TrustPilot.vue";
import { useStore } from "vuex";
import { FinishInfoResponse } from "../ts/response/finishInfoResponse";
import EffectOfHigherCharges from "./finish/EffectOfHigherCharges.vue";
import ProvidersList from "./common/ProvidersList.vue";
import WhatsInYourDesign from "./finish/WhatsInYourDesign.vue";
import Assumptions from "./finish/Assumptions.vue";
import { Retiree } from "../ts/retiree";
import { workflow } from "../ts/workflow/workflow";
import View from "../ts/view";
import Monitoring from "../ts/monitoring/monitoring";
import FinalSalarySchemeSupport from "@/guiide/components/common/DBOptions/FinalSalarySchemeSupport.vue";
import SubSection from '@/guiide/components/common/SubSection.vue';

type NextButtonInfo = { display: boolean, link: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'Finish',
  setup(__props) {

const store = useStore();
const retiree = computed<Retiree | null>(() => store.state.retiree);
const finishInfo = computed<FinishInfoResponse | null>(() => store.state.finishInfo);
const nextButtonInfo = ref<NextButtonInfo>({ display: false, link: "" });

onMounted(async() => {
    const nextWorkflowStep = await workflow.getNextWorkflowStep(View.Finish);

    if (nextWorkflowStep == null) {
        nextButtonInfo.value = { display: false, link: "" };
        return;
    }

    nextButtonInfo.value = { display: true, link: nextWorkflowStep.resource };
});

const disclaimer = computed<string>(() => store.state.configuration.disclaimer);

const displayTrustpilot = computed<boolean>(() => store.state.configuration.showTrustpilot);
const displayPoweredBy = computed<boolean>(() => store.state.configuration.showPoweredBy);

const displayProviders = computed<boolean>(() => store.state.configuration.finishDisplaysProviders);
const displayAnnuityProviders = computed<boolean>(() => store.state.configuration.finishDisplaysAnnuity);

// If the footer is shown, we expect the disclaimer to be shown there - i.e. no need to display here.
const showDisclaimer = computed<boolean>(() => !(store.state.configuration?.footer?.visibleInAuthApp ?? false));

const schemeSupportMode = computed<string | undefined>(() => retiree.value?.finalSalaries?.schemes[0]?.supportMode);

function onViewed() {
    Monitoring.trackEvent('stepCompleted', { stepName: 'Finish' });
}

return (_ctx: any,_cache: any) => {
  const _directive_in_view = _resolveDirective("in-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(WorkflowNavigation, { workflowStage: "Finish" }),
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "skin-page-heading" }, " Your plan ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-check-circle-fill text-success display-2" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(WhatsInYourDesign, { retiree: retiree.value }, null, 8, ["retiree"]),
      _withDirectives(_createVNode(Plan, {
        retiree: retiree.value,
        "finish-info": finishInfo.value
      }, null, 8, ["retiree", "finish-info"]), [
        [_directive_in_view, onViewed]
      ]),
      _createVNode(OrigenAdvice),
      _createVNode(GenericCostOfAdvice),
      _createVNode(OptionsNowYouHaveAPlan),
      _createVNode(EffectOfHigherCharges, { "finish-info": finishInfo.value }, null, 8, ["finish-info"]),
      (displayProviders.value)
        ? (_openBlock(), _createBlock(ProvidersList, {
            key: 0,
            "show-charges": false,
            "show-cost-comparison-alert": true,
            title: "If you just want to find a low cost provider yourself"
          }))
        : _createCommentVNode("", true),
      _createVNode(AdvisorsList),
      (displayAnnuityProviders.value)
        ? (_openBlock(), _createBlock(AnnuityProvidersList, { key: 1 }))
        : _createCommentVNode("", true),
      (schemeSupportMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SubSection, {
                title: "Next steps",
                showHelp: false
              }, {
                default: _withCtx(() => [
                  _createVNode(FinalSalarySchemeSupport, { schemeSupportMode: schemeSupportMode.value }, null, 8, ["schemeSupportMode"])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(Assumptions, { retiree: retiree.value }, null, 8, ["retiree"]),
      _createVNode(RiskWarnings),
      (showDisclaimer.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("footer", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_8, [
                    _createElementVNode("span", { innerHTML: disclaimer.value }, null, 8, _hoisted_9)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (displayTrustpilot.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(TrustPilot)
            ])
          ]))
        : _createCommentVNode("", true),
      (displayPoweredBy.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "col text-center" }, [
              _createElementVNode("div", { class: "powered-by-guiide" }, [
                _createElementVNode("div", null, "Powered By"),
                _createElementVNode("img", {
                  src: "/Content/images/logo.png",
                  class: "poweredByGuiide",
                  alt: "Powered by Guiide"
                })
              ])
            ], -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(PageNav, {
        "show-next": nextButtonInfo.value.display,
        "back-link": "test",
        "next-link": nextButtonInfo.value.link
      }, null, 8, ["show-next", "next-link"])
    ])
  ]))
}
}

})